import { Outlet } from 'react-router';
import * as S from './styles';

const Layout = () => {
	//--- RENDERING
	return (
		<S.Base>
			<S.Content>
				<Outlet />
			</S.Content>
		</S.Base>
	);
};

export default Layout;
